export class UserCompanyInfo {
  private telephone: string;
  private fiscalNumber: string;
  private corporateName: string;
  private healthProfessional: boolean;
  private classCouncil: string;
  private registrationNumber: string;

  setTelephone(value: string): void {
    this.telephone = value;
  }

  getTelephone(): string {
    return this.telephone;
  }

  isMobile(): boolean {
    return !!this.telephone ? this.telephone.replace(/[^\d]+/g, "").length === 11 : false;
  }

  setFiscalNumber(value: string): void {
    this.fiscalNumber = value;
  }

  getFiscalNumber(): string {
    return this.fiscalNumber;
  }

  setHealthProfessional(value: boolean): void {
    this.healthProfessional = value;
  }

  isHealthProfessional(): boolean {
    return this.healthProfessional;
  }

  setClassCouncil(value: string): void {
    this.classCouncil = value;
  }

  getClassCouncil(): string {
    return this.classCouncil;
  }

  setRegistrationNumber(value: string): void {
    this.registrationNumber = value;
  }

  getRegistrationNumber(): string {
    return this.registrationNumber;
  }

  getCorporateName(): string {
    return this.corporateName;
  }

  setCorporateName(value: string) {
    this.corporateName = value;
  }
}